// extracted by mini-css-extract-plugin
export default {"container":"LoadingDot_container__iw6wG","dots_1":"LoadingDot_dots_1__P8Gz1","d1":"LoadingDot_d1__97vJs"};